export default {"src":"/_next/static/media/bikeOutline75_40.2a06f6ab.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};